import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from '@dr.pogodin/react-helmet';

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import OurStory from "./pages/OurStory";
import Craftsmanship from "./pages/Craftsmanship";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import StickyCTA from "./components/StickyCTA";

import ConsultationModal from "./components/ConsultationModal";
import ScrollToTop from "./components/ScrollToTop";

// import "./App.css"; // Migrating to Tailwind

function App() {
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(true);
  const [isStickyCtaVisible, setIsStickyCtaVisible] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [heroHeight, setHeroHeight] = useState(0);

  useEffect(() => {
    setIsHomePage(location.pathname === "/");
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      if (isHomePage) {
        if (heroHeight > 0 && window.scrollY > heroHeight) {
          setIsStickyCtaVisible(true);
        } else {
          setIsStickyCtaVisible(false);
        }
      } else {
        setIsStickyCtaVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isHomePage, heroHeight]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);



  return (
    <HelmetProvider>
      <>
        <ScrollToTop />
        <Header openModal={openModal} setHeaderHeight={setHeaderHeight} />
        <StickyCTA onClick={openModal} isVisible={isStickyCtaVisible} top={headerHeight} />
        <main>
          <Routes>
            <Route path="/" element={<Home openModal={openModal} setHeroHeight={setHeroHeight} />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/craftsmanship" element={<Craftsmanship />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <ConsultationModal isOpen={isModalOpen} onClose={closeModal} />
      </>
    </HelmetProvider>
  );
}

export default App;
